import { __decorate } from "tslib";
import { Component } from 'decorators';
import './noTemplatesFound.scss';
import template from './NoTemplatesFoundView.html';
let NoTemplatesFoundComponent = class NoTemplatesFoundComponent {
};
NoTemplatesFoundComponent = __decorate([
    Component({
        template,
        bindings: {
            notFoundMessage: '@?',
            canCreateTemplate: '<?',
            searchText: '@?',
        },
    })
], NoTemplatesFoundComponent);
export { NoTemplatesFoundComponent };
